/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsPackageListItem,
    IdentityMelcoModelsPackageListItemFromJSON,
    IdentityMelcoModelsPackageListItemFromJSONTyped,
    IdentityMelcoModelsPackageListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsPackageListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsPackageListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsPackageListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPackageListItem
     */
    list: Array<IdentityMelcoModelsPackageListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPackageListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPackageListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsPackageListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsPackageListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsPackageListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsPackageListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsPackageListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsPackageListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsPackageListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsPackageListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsPackageListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


